import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import BackNext from '../../Common/SubComponents/BackNext';
import { Form, Row, Col, Container } from 'react-bootstrap';
import { ConvertStringToBoolean, ConvertBooleanToString } from '../../../Helpers/Formatters/ConvertBoolean';
import FormControl from '@material-ui/core/FormControl';
import { CheckboxInput } from '../../../Helpers/Inputs';
import watch from '../icons/watch.svg';
import { FLORIDA, NEW_YORK } from '../../../Helpers/Constants/States';
import SvgIcon from '@material-ui/core/SvgIcon';
import IneligibleForm from '../Helpers/Input/IneligibleForm';
import { string, object, array as yuparray } from 'yup';
import { customValidators } from '../../../Helpers/Validators/customValidators'
export default function ThreeYearEligibility(props) {
  const { register, errors, handleSubmit, setValue, triggerValidation, reset } = useForm({
    validationSchema: ThreeYearEligibility.ValidationSchema(),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const ineligibleDefault = [
    {
      type: '',
      name: [],
      numberOfChildren: '',
      nameofChildren: [],
    },
  ];
  useEffect(() => {
    props.onFieldChange("isVisible", true);
  }, [])

  const state = props.basicInfo.state;
  useEffect(() => {
    register({ name: 'heartRelatePain' });
    setValue('heartRelatePain', props.formState.heartRelatePain);
    register({ name: 'atrialFibrillation' });
    setValue('atrialFibrillation', props.formState.atrialFibrillation);
    register({ name: 'pancreatitis' });
    setValue('pancreatitis', props.formState.pancreatitis);

    register({ name: 'crohnsDisease' });
    setValue('crohnsDisease', props.formState.crohnsDisease);
    register({ name: 'alzheimersDisease' });
    setValue('alzheimersDisease', props.formState.alzheimersDisease);

    register({ name: 'heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant' });
    setValue('heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant', props.formState.heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant);

    register({ name: 'peripheralVascularDisease' });
    setValue('peripheralVascularDisease', props.formState.peripheralVascularDisease);

    register({ name: 'ulcerativeColitisOrProctitis' });
    setValue('ulcerativeColitisOrProctitis', props.formState.ulcerativeColitisOrProctitis);

    register({ name: 'parkinsonsDisease' });
    setValue('parkinsonsDisease', props.formState.parkinsonsDisease);
    register({ name: 'senileDementia' });
    setValue('senileDementia', props.formState.senileDementia);

    props.formState.ineligible.forEach((ineligible, index) => {
      register({ name: `ineligible[${index}].type` });
      setValue(`ineligible[${index}].type`, ineligible.type);

      register({ name: `ineligible[${index}].name` });
      setValue(`ineligible[${index}].name`, ineligible.name);

      register({ name: `ineligible[${index}].numberOfChildren` });
      setValue(`ineligible[${index}].numberOfChildren`, ineligible.numberOfChildren);

      register({ name: `ineligible[${index}].nameofChildren` });
      setValue(`ineligible[${index}].nameofChildren`, ineligible.nameofChildren);
    });
  }, [register]);

  const handleValueChangeWithIneligible = (field, value) => {
    props.onFieldChange(field, ConvertBooleanToString(value));
    if (value === true) {
      const newBeneIndex = props.formState.ineligible.length;
      register({ name: `ineligible[${newBeneIndex}].type` });
      register({ name: `ineligible[${newBeneIndex}].name` });
      register({ name: `ineligible[${newBeneIndex}].numberOfChildren` });
      register({ name: `ineligible[${newBeneIndex}].nameofChildren` });
      let newForm = ineligibleDefault;
      newForm[0].type = field;
      props.onStepFieldChange(field, ConvertBooleanToString(value), 'ineligible', [...props.formState.ineligible, newForm[0]]);
    } else {
      props.onStepFieldChange(
        field,
        ConvertBooleanToString(value),
        'ineligible',
        props.formState.ineligible.filter((form, formIndex) => form.type !== field)
      );
      const selectedForm = props.formState.ineligible.filter((form, formIndex) => form.type === field);
      const newForms = props.formState.ineligible.filter((form, formIndex) => form.type !== field);
      let selectedFormIndex;
      if (props.formState.ineligible.length > 0) {
        selectedFormIndex = props.formState.ineligible.findIndex((form) => form.type === field);
      }
      if (selectedForm.length > 0 && selectedFormIndex >= 0) {
        register({ name: 'ineligible' });
        setValue('ineligible', newForms);
      }
      // reset();
    }
  };

  const getLabelForMedicalIssues = () => {
    if (state === FLORIDA) {
      return 'Within the last three years, has anyone to be covered been medically treated or diagnosed by a licensed member of the medical profession for any of the following?';
    } else if (state === NEW_YORK) {
      return 'To the best of your knowledge and belief, within the last three years, has anyone to be covered been medically treated or diagnosed by a member of the medical profession for any of the following?';
    } else {
      return 'Within the last three years, has anyone to be covered been medically treated or diagnosed by a member of the medical profession for any of the following?';
    }
  };

  const noneOfTheAboveDisabled =
    props.formState.heartRelatePain === 'true' ||
    props.formState.atrialFibrillation === 'true' ||
    props.formState.pancreatitis === 'true' ||
    props.formState.crohnsDisease === 'true' ||
    props.formState.alzheimersDisease === 'true' ||
    props.formState.heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant === 'true' ||
    props.formState.peripheralVascularDisease === 'true' ||
    props.formState.ulcerativeColitisOrProctitis === 'true' ||
    props.formState.parkinsonsDisease === 'true' ||
    props.formState.senileDementia === 'true';

  useEffect(() => {
    if (noneOfTheAboveDisabled && props.formState.none === 'true') {
      props.onFieldChange('none', 'false');
    } else if (noneOfTheAboveDisabled && props.formState.none !== 'true') {
      triggerValidation('none');
    }
    else if(!noneOfTheAboveDisabled && props.formState.none === 'false')
    {
      props.onFieldChange('none', 'true');
    } 
  }, [noneOfTheAboveDisabled]);

  const getIneligibleComponent = (field, list) => {
    let item;
    list.map((ineligible, index) => {
      if (ineligible.type === field) {
        item = ineligible;
        item.index = index;
      }
    });
    const handleValueChangeloop = (field, type, value, longFieldName) => {
      setValue(longFieldName, value);
      props.onFieldChange(
        'ineligible',
        props.formState.ineligible.map((form, formIndex) => {
          if (type === form.type) {
            if (field === "name")
              form[field] = value;
            else
              eval('form.' + field + '=' + `'${value}'`);
            return form;
          } else {
            return form;
          }
        })
      );
    };
    const handleChildrenNames = (field, type, value, longFieldName) => {
      setValue(longFieldName, value);

      props.onFieldChange(
        'ineligible',
        props.formState.ineligible.map((form, formIndex) => {
          if (type === form.type) {
            if (field === 'numberOfChildren') {
              eval('form.' + field + '=' + `'${value}'`);
              const previousChildLength = form.nameofChildren.length;
              const totalChild = parseInt(value);
              if (totalChild > previousChildLength) {
                const addChildInput = totalChild - previousChildLength;
                for (let i = 1; i <= addChildInput; i++) {
                  if (type === form.type) {
                    form.nameofChildren.push({ name: '' });
                  }
                }
              } else {
                const removeChildInput = previousChildLength - totalChild;
                form.nameofChildren.splice(`-${removeChildInput}`);
              }
              reset();
              return form;
            }
          } else {
            if (type === form.type) {
              eval('form.' + field + '=' + `'${value}'`);
              return form;
            } else {
              return form;
            }
          }
        })
      );
    };
    if (item) {
      return (
        <div>
          <IneligibleForm
            formState={item}
            onChange={(field, value, type, longFieldName) => {
              handleValueChangeloop(field, type, value, longFieldName);
            }}
            ChildChange={(field, value, type, longFieldName) => {
              handleChildrenNames(field, type, value, longFieldName);
            }}
            allProps={props}
            setValue={setValue}
            trigger={triggerValidation}
            key={item.index}
            index={item.index}
            register={register}
            customOption={props.getListOfPlanIncludedPerson()}
            noOfChilds={props.noOfChilds ? props.noOfChilds : ''}
            errors={errors.ineligible && errors.ineligible[item.index]}
          />
        </div>
      );
    }
  };

  return (
    <Container fluid className="border-class threeYearEligibility">
      <Row className="justify-content-center">
        <Col>
          <Form className="formPage" onSubmit={handleSubmit(props.onNext)}>
            <Row className="justify-content-center mt-4">
              <Col lg={6}>
                <div className="text-center mb-2 pt-4">
                  {' '}
                  <SvgIcon component={watch} className="small-icons" color="primary" fontSize="large" />
                </div>
                <div className="text-center form-title pb-2">3 Year Medical History</div>
              </Col>
            </Row>
            <Row className="formPage justify-content-center">
              <Col lg={5}>
                {/* <FormControl component="fieldset"> */}
                <h6 className='pb-1'>{getLabelForMedicalIssues()}</h6>
                <Form.Group className="checkboxes">
                  <CheckboxInput
                    name="heartRelatePain"
                    id="heartRelatePain"
                    checked={ConvertStringToBoolean(props.formState.heartRelatePain)}
                    onChange={(e) => handleValueChangeWithIneligible('heartRelatePain', e.target.checked)}
                    errors={errors.heartRelatePain}
                    inputRef={register}
                    label="Heart-related chest pain (including angina or acute coronary syndrome)"
                  />
                </Form.Group>
                {props.formState.heartRelatePain === 'true' && getIneligibleComponent('heartRelatePain', props.formState.ineligible)}
                <Form.Group className="checkboxes">
                  <CheckboxInput
                    name="atrialFibrillation"
                    id="atrialFibrillation"
                    checked={ConvertStringToBoolean(props.formState.atrialFibrillation)}
                    onChange={(e) => handleValueChangeWithIneligible('atrialFibrillation', e.target.checked)}
                    errors={errors.atrialFibrillation}
                    inputRef={register}
                    label="Atrial fibrillation"
                  />
                </Form.Group>
                {props.formState.atrialFibrillation === 'true' && getIneligibleComponent('atrialFibrillation', props.formState.ineligible)}
                <Form.Group className="checkboxes">
                  <CheckboxInput
                    name="pancreatitis"
                    id="pancreatitis"
                    checked={ConvertStringToBoolean(props.formState.pancreatitis)}
                    onChange={(e) => handleValueChangeWithIneligible('pancreatitis', e.target.checked)}
                    errors={errors.pancreatitis}
                    inputRef={register}
                    label="Pancreatitis"
                  />
                </Form.Group>
                {props.formState.pancreatitis === 'true' && getIneligibleComponent('pancreatitis', props.formState.ineligible)}
                <Form.Group className="checkboxes">
                  <CheckboxInput
                    name="crohnsDisease"
                    id="crohnsDisease"
                    checked={ConvertStringToBoolean(props.formState.crohnsDisease)}
                    onChange={(e) => handleValueChangeWithIneligible('crohnsDisease', e.target.checked)}
                    errors={errors.crohnsDisease}
                    inputRef={register}
                    label="Crohn's disease"
                  />
                </Form.Group>
                {props.formState.crohnsDisease === 'true' && getIneligibleComponent('crohnsDisease', props.formState.ineligible)}
                <Form.Group className="checkboxes">
                  <CheckboxInput
                    name="alzheimersDisease"
                    id="alzheimersDisease"
                    checked={ConvertStringToBoolean(props.formState.alzheimersDisease)}
                    onChange={(e) => handleValueChangeWithIneligible('alzheimersDisease', e.target.checked)}
                    errors={errors.alzheimersDisease}
                    inputRef={register}
                    label="Alzheimer's disease"
                  />
                </Form.Group>
                {props.formState.alzheimersDisease === 'true' && getIneligibleComponent('alzheimersDisease', props.formState.ineligible)}
                <Form.Group className="checkboxes">
                  <CheckboxInput
                    name="heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant"
                    id="heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant"
                    checked={ConvertStringToBoolean(props.formState.heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant)}
                    onChange={(e) => handleValueChangeWithIneligible('heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant', e.target.checked)}
                    errors={errors.heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant}
                    inputRef={register}
                    label="Heart disease or disorder with pacemaker or defibrillator implant"
                  />
                </Form.Group>
                {props.formState.heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant === 'true' &&
                  getIneligibleComponent('heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant', props.formState.ineligible)}
                <Form.Group className="checkboxes">
                  <CheckboxInput
                    name="peripheralVascularDisease"
                    id="peripheralVascularDisease"
                    checked={ConvertStringToBoolean(props.formState.peripheralVascularDisease)}
                    onChange={(e) => handleValueChangeWithIneligible('peripheralVascularDisease', e.target.checked)}
                    errors={errors.peripheralVascularDisease}
                    inputRef={register}
                    label="Peripheral vascular disease (circulatory problems)"
                  />
                </Form.Group>
                {props.formState.peripheralVascularDisease === 'true' && getIneligibleComponent('peripheralVascularDisease', props.formState.ineligible)}
                <Form.Group className="checkboxes">
                  <CheckboxInput
                    name="ulcerativeColitisOrProctitis"
                    id="ulcerativeColitisOrProctitis"
                    checked={ConvertStringToBoolean(props.formState.ulcerativeColitisOrProctitis)}
                    onChange={(e) => handleValueChangeWithIneligible('ulcerativeColitisOrProctitis', e.target.checked)}
                    errors={errors.ulcerativeColitisOrProctitis}
                    inputRef={register}
                    label="Ulcerative colitis or proctitis"
                  />
                </Form.Group>
                {props.formState.ulcerativeColitisOrProctitis === 'true' && getIneligibleComponent('ulcerativeColitisOrProctitis', props.formState.ineligible)}
                <Form.Group className="checkboxes">
                  <CheckboxInput
                    name="parkinsonsDisease"
                    id="parkinsonsDisease"
                    checked={ConvertStringToBoolean(props.formState.parkinsonsDisease)}
                    onChange={(e) => handleValueChangeWithIneligible('parkinsonsDisease', e.target.checked)}
                    errors={errors.parkinsonsDisease}
                    inputRef={register}
                    label="Parkinson's disease"
                  />
                </Form.Group>
                {props.formState.parkinsonsDisease === 'true' && getIneligibleComponent('parkinsonsDisease', props.formState.ineligible)}
                <Form.Group className="checkboxes">
                  <CheckboxInput
                    name="senileDementia"
                    id="senileDementia"
                    checked={ConvertStringToBoolean(props.formState.senileDementia)}
                    onChange={(e) => handleValueChangeWithIneligible('senileDementia', e.target.checked)}
                    errors={errors.senileDementia}
                    inputRef={register}
                    label="Senile dementia"
                  />
                </Form.Group>
                {props.formState.senileDementia === 'true' && getIneligibleComponent('senileDementia', props.formState.ineligible)}
                <Form.Group className="checkboxes">
                  <CheckboxInput
                    name="none"
                    id="none"
                    checked={noneOfTheAboveDisabled === true ? false : true}
                    //checked={ConvertStringToBoolean(props.formState.none)}
                    onChange={(e) => handleValueChangeWithIneligible('none', e.target.checked)}
                    errors={errors.none}
                    inputRef={register}
                    label="None of the above"
                    disabled={noneOfTheAboveDisabled}
                  />
                </Form.Group>
                {/* </FormControl> */}
              </Col>
            </Row>
            <div className='backnext-wrapper'>
              <BackNext onBack={props.onBack} isAflac={true} continueLabel={{text: "Next"}} />
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

ThreeYearEligibility.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func,
  onFieldChange: PropTypes.func.isRequired,
  onBack: PropTypes.func,
};

ThreeYearEligibility.ValidationSchema = () => {
  return object().shape({
    ineligible: yuparray(
      object().shape({
        name: string().required('Name is required.'),
        numberOfChildren: string().when('name', {
          is: (name) => name && name.includes('Dependent Child'),
          then: string().required('This field is required.'),
          otherwise: string().notRequired(),
        }),
        nameofChildren: yuparray().when('name', {
          is: (name) => name && name.includes('Dependent Child'),
          then: yuparray(
            object().shape({
              name: customValidators.string().isValidNameWithFiftyChar('Child Name is required.', true),
            })
          ),
        }),
      })
    ),
  });
};

ThreeYearEligibility.DefaultFormState = (prefill = false) => {
  return {
    heartRelatePain: 'false',
    atrialFibrillation: 'false',
    pancreatitis: 'false',
    crohnsDisease: 'false',
    alzheimersDisease: 'false',
    heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant: 'false',
    peripheralVascularDisease: 'false',
    ulcerativeColitisOrProctitis: 'false',
    parkinsonsDisease: 'false',
    senileDementia: 'false',
    none: 'true',
    ineligible: [],
    isVisible: false,
  };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/ThreeYearEligibility.js